export default __webpack_public_path__ + "static/media/job.5c2b2903.svg";